/** Share of the מענה חסר priority score that comes from cooperation level. */
export const COVERAGE_COOPERATION_WEIGHT = 0.4;
/** Share of the מענה חסר priority score that comes from fill rate. */
export const COVERAGE_FILL_WEIGHT = 0.6;

/** 1 is best, 9 is worst. Missing ranks after 9. */
export function coverageCooperationSortValue(
  cooperationLevel: number | null | undefined,
): number {
  return cooperationLevel == null || cooperationLevel < 1 ? 10 : cooperationLevel;
}

/** 0 = most urgent (level 1), 100 = least urgent (missing). */
export function coverageCooperationUrgency(
  cooperationLevel: number | null | undefined,
): number {
  return ((coverageCooperationSortValue(cooperationLevel) - 1) / 9) * 100;
}

/**
 * Lower score is more urgent.
 * Seriousness is 40% and fill rate is 60%.
 */
export function partnerOrgCoveragePriorityScore(
  fillRatePercent: number,
  cooperationLevel: number | null | undefined,
): number {
  return (
    COVERAGE_COOPERATION_WEIGHT * coverageCooperationUrgency(cooperationLevel) +
    COVERAGE_FILL_WEIGHT * fillRatePercent
  );
}

export function comparePartnerOrgCoverage(
  a: {
    cooperationLevel: number | null | undefined;
    fillRatePercent: number;
  },
  b: {
    cooperationLevel: number | null | undefined;
    fillRatePercent: number;
  },
): number {
  const score =
    partnerOrgCoveragePriorityScore(a.fillRatePercent, a.cooperationLevel) -
    partnerOrgCoveragePriorityScore(b.fillRatePercent, b.cooperationLevel);
  if (score !== 0) return score;
  return a.fillRatePercent - b.fillRatePercent;
}
